import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { DASHBOARD_SELECT_STYLES } from '../utils/dashboardHelpers';

const OPTION_SHAPE = PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
});

export const DashboardSelector = ({ options, value, onChange }) => (
    <div className="dashboard__selector">
        <label className="dashboard__selector-label">Dashboard</label>
        <Select
            value={value}
            onChange={onChange}
            options={options}
            styles={DASHBOARD_SELECT_STYLES}
            isSearchable={false}
        />
    </div>
);

DashboardSelector.propTypes = {
    options: PropTypes.arrayOf(OPTION_SHAPE).isRequired,
    value: OPTION_SHAPE,
    onChange: PropTypes.func.isRequired,
};
